/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Module, SCS) {
	'use strict';
	/*jshint smarttabs:true */

	/**
	 * GridLayout module implementation.
	 *
	 * @author Rami Attallah
	 * @namespace Tc.Module
	 * @class GridLayout
	 * @extends Tc.Module
	 */
	Module.GridLayout = Module.extend({
		syncHeights: false,
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this;
			mod.syncHeights = mod.$ctx.hasClass('scs-html-sync-height');

			callback();
		},

		after: function() {
			var mod = this;
			if(mod.syncHeights) {
				mod.$ctx.parents('body').on('sync-heights', function() {
					var teasers = mod.$ctx.find('.sync-wrapper');
					SCS.portal.synchronizeHeights(teasers);
				});
			}
		}
	});
}(window.Tc.$, window.Tc.Module, window.SCS = window.SCS || {}));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.GridLayout.js
// module id = 143
// module chunks = 0